<template>
  <!--
    作者：yangxiaojun
    时间：2020-09-03
    描述：插件中心-供应商设置
  -->
  <div class="user">
     <el-form-item label="开启供应商">
        <div>
          <el-radio v-model="form.is_open" :label="1">开</el-radio>
          <el-radio v-model="form.is_open" :label="0">关</el-radio>
        </div>
      </el-form-item>     
      <!-- <el-form-item label="开启前端供应商申请入驻">
        <div>
          <el-radio v-model="form.is_apply_open" :label="1">开</el-radio>
          <el-radio v-model="form.is_apply_open" :label="0">关</el-radio>
        </div>
      </el-form-item> -->

      <el-form-item label="填系统码申请的用户免审核">
        <div>
          <el-input v-model="form.numb" type="text"  class="max-w460"></el-input>
        </div>
      </el-form-item>

      <el-form-item label="商家默认Logo">
        <div class="d-c-c ad-picture" style="width: 150px;height: 150px;" @click="openUpload(3)">
        <img v-if="form.logo_image_id > 0" :src="form.logo_file_path" width="200" height="200" />
        <span v-else class="el-icon-picture-outline"></span>
      </div>
      <p class="ml10 gray">提示：图片尺寸建议200x200</p>
      </el-form-item>


<!-- 
      <el-form-item label="服务" >
        <el-button size="small" type="primary" @click="addService" >新增服务</el-button>
        <el-table :data="form.service"  border size="mini" style="width: 100%;margin-top: 20px;">
          <el-table-column prop="name" label="编号"  >
              <template v-slot="scope">
                <div class="d-s-c">
               
                  {{ scope.row.code }}
                </div>
              </template>
            </el-table-column>
          <el-table-column prop="name" label="排序"  >
              <template v-slot="scope">
                <div class="d-s-c">
                  <el-input style="width: 150px;"  v-model="scope.row.sort"  placeholder="请输入排序"></el-input>
                </div>
              </template>
            </el-table-column>


            <el-table-column prop="name" label="服务名称"   width="200" >
              <template v-slot="scope">
                <div class="d-s-c">
                  <el-input style="width: 150px;" type="textarea" v-model="scope.row.name"  placeholder="请输入服务名称"></el-input>
                </div>
              </template>
            </el-table-column>     


  
            <el-table-column prop="name" label="操作"  width="100">
              <template v-slot="scope">
                <div style="color: blue;" @click="delService(scope.$index)">删除</div>

              </template>
            </el-table-column>
          </el-table>
      </el-form-item>  -->



      <!-- <el-form-item label="允许用户申请">
        <div>
          <el-radio v-model="form.is_apply" :label="1">是</el-radio>
          <el-radio v-model="form.is_apply" :label="0">否</el-radio>
        </div>
      </el-form-item>
      <el-form-item label="商品刷新积分消耗">
        <div>
         <el-input class="max-w460" type="number" min="0" v-model="form.promotion_points" ></el-input>
        </div>
      </el-form-item>
      <el-form-item label="是否需要实名认证">
        <div>
          <el-radio  v-model="form.need_certification" :label="0">不需要</el-radio>
          <el-radio  v-model="form.need_certification" :label="1">实名认证【可不审核】</el-radio>
          <el-radio  v-model="form.need_certification" :label="2">实名认证【必须审核】</el-radio>
        </div>
      </el-form-item>
      
      <el-form-item label="可申请级别">
        <el-select v-model="form.grade" multiple placeholder="请选择">
          <el-option
            v-for="item in options"
            :key="item.kmd_grade_id"
            :label="item.name"
            :value="item.kmd_grade_id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="申请广告图">
        <div class="d-c-c ad-picture" @click="openUpload(2)">
        <img v-if="form.banner_image_id > 0" :src="form.banner_file_path" width="300" height="124" />
        <span v-else class="el-icon-picture-outline"></span>
      </div>
      <p class="ml10 gray">提示：图片尺寸建议750x310</p>
      </el-form-item>
      <el-form-item label="申请说明">
        <el-row>
          <el-button icon="el-icon-picture-outline" @click="openUpload(0)">选择图片</el-button>
          <div v-if="form.image_id!=''" class="img">
            <img :src="form.file_path" width="100" height="100" />
          </div>
        </el-row>
         <p class="gray">建议宽度750px，高度不限，建议小于500K</p>
      </el-form-item> -->
    <!--上传图片组件-->
    <Upload v-if="isupload" :isupload="isupload" @returnImgs="returnImgsFunc">上传图片</Upload>
  </div>
</template>
<script>
// import SupplyApi from '@/api/supply.js';
import Upload from '@/components/file/Upload';
export default {
  components: {
    /*选择商品组件*/
    Upload,
  },
  
  data() {
    return {
       /*是否上传图片*/
      isupload: false,

    };
  },
  props: {
    form: Object,
    options: Array
  },
  methods: {
    delService(index){
        this.form.service.splice(index,1)
    },
      addService(){
        this.form.service.push({
          "code":this.randomString(8,this.randomString(6,0)),
          "sort":50,
          "name":"",
        });
      },

    // 上传
     openUpload(e) {
      this.isupload = true;
      this.uploadtype= e;
    },
      /*获取图片*/
    returnImgsFunc(e) {
      if (e != null && e.length > 0) {
        if(this.uploadtype==0){
          this.form.file_path = e[0].file_path;
          this.form.image_id = e[0].file_id;
        }else if(this.uploadtype==2){
          this.form.banner_file_path = e[0].file_path;
           this.form.banner_image_id = e[0].file_id;
        }else if(this.uploadtype==3){
          this.form.logo_file_path = e[0].file_path;
           this.form.logo_image_id = e[0].file_id;
        }
        
      }
      this.isupload = false;
    },
  }
  
};
</script>

<style>
.ad-picture {
  width: 300px;
  height: 124px;
  border-radius: 16px;
  font-size: 40px;
  border: 1px dashed #cccccc;
  color: $blue;
  cursor: pointer;
  overflow: hidden;
}
 .ad-picture:hover {
  border: 1px dashed $blue;
}

 .ad-picture img {
  object-fit: fill;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/supply/setting/part/Basic.vue